// engagement routes
import engagementDetailRoute from '../../../pages/EngagementDetailPage/route';

const openEngagementHandler =
  ({companyId, engagementId, navigate}) =>
  () =>
    navigate(engagementDetailRoute({companyId, engagementId}));

export default openEngagementHandler;
